export enum LayoutViewEnum {
  mobile = 'mobile',
  web = 'web'
}

export enum ContextAction {
  setScreen = 'SET_SCREEN',
  setUserName = 'SET_USERNAME',
  setUserId = 'SET_USERID',
  setGenderConfig = 'SET_GENDER_CONFIG',
  setNationalityConfig = 'SET_NATIONALITY_CONFIG',
  setSalutationonfig = 'SET_SALUTATION_CONFIG',
  setAuthenticationConfig = 'SET_AUTHENTICATION_CONFIG',
  setProfessionConfig = 'SET_PROFESSION_CONFIG'
}

export interface gender {
  key: string;
  value: string;
  label: string;
}
export interface salutation {
  key: string;
  value: string;
  label: string;
}
export interface nationality {
  code: string;
  label: string;
  value: string;
  countryName: string;
  mobileConfig: {
    code: string;
    minLength: number;
    maxLength: number;
  };
}

export interface profession {
  key: string;
  value: string;
  label: string;
}

export enum LogInType {
  Mobile = 'mobile',
  Email = 'email'
}
